module.exports = __webpack_public_path__ + "static/media/infoAlert.e495d55d.svg";